import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div
        className={`section-header-wrapper ${data.size} ${data.mainLayerStyles}`}
      >
        {data.title}
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultdata = {};

export default Index;
